<template>

    <van-form class="container" @submit="onSubmit" >

        <div class="container zx-fill-ticket-info">

            <div class="header f-s-b">
                <div class="header-item header-item-active theme-color-font">填写预约信息</div>
                <div class="header-item item-line " ></div>
                <div class="header-item">预约成功</div>
            </div>

            <div class="body g-big-tree-bg">
                
                <!-- 预约信息 -->
                <ul class="body-rander-item ">
                    <li class="row-box info-row info-title ">
                        <div class="inner-row f-s-b">
                            <div class="info-left">
                                <i class="iconhebei iconhuodong3 theme-color-font icon-size"></i>
                                <span>2019年亲子活动(免费)</span>
                            </div>
                            <div class="info-right f-c ellipsis">
                                <span>剩余名额:</span>
                                <span class="g-yellow-color count g-b-500">20</span>
                            </div>
                        </div>
                    </li>
                    <li class="row-box info-row f-c">
                        <i class="iconhebei iconshizhong g-yellow-color"></i>
                        <span class="left-txt f-s-b">
                            <span v-for="(item, index) in [ '活', '动' ,'时', '间' ]" :key="index">{{item}}</span>
                        </span>
                        <span class="right-txt">: {{option._startTimeStr}} - {{option._endTimeStr}}</span>
                    </li>
                    <li class="row-box info-row f-c">
                        <i class="iconhebei iconnianling g-green-color"></i>
                        <span class="left-txt f-s-b">
                            <span v-for="(item, index) in [ '报', '名', '条', '件' ]" :key="index">{{item}}</span>
                        </span>
                        <span class="right-txt">: {{ (option.minAge>0 && option.maxAge>0) ? `${option.minAge} - ${option.maxAge}岁`:`无年龄限制` }}</span>
                    </li>
                    <li class="row-box info-row f-c">
                        <i class="iconhebei iconprice g-yellow-color"></i>
                        <span class="left-txt f-s-b">
                            <span v-for="(item, index) in [ '费', '用' ]" :key="index">{{item}}</span>
                        </span>
                        <span class="right-txt">: {{option.isCharge === 0 ? '免费': `${option.price}元`}}</span>
                    </li>
                    <li class="row-box info-row f-c">
                        <i class="iconhebei iconrenshu g-violet-color"></i>
                        <span class="left-txt f-s-b">
                            <span v-for="(item, index) in [ '报', '名', '限', '制' ]" :key="index">{{item}}</span>
                        </span>
                        <span class="right-txt">: {{option.limitCount > 0 ? `${option.limitCount}人`:'无人数限制'}}</span>
                    </li>

                </ul>

                <div class="contacts-title-box f-s-b g-b-500">
                    <div>
                        <span>联系人</span>
                    </div>
                </div>

                <ul class="body-rander-item explain-home-info-input" style="margin:0;">
                    <li class="row-box">
                        <van-field
                            class="item-row f-s-b user-name"
                            v-model.trim="contactsInfo.name"
                            required
                            :name="`name`"
                            :border="false"
                            label="姓名"
                            placeholder="请输入联系人姓名"
                            :rules="[{ required: true, message: '请正确填写联系人姓名', validator: checkName }]"
                        />
                    </li>
                    <li class="row-box">
                        <van-field
                            class="item-row f-s-b user-name"
                            v-model.trim="contactsInfo.phone"
                            required
                            type="tel"
                            maxlength="11"
                            name="phone"
                            :border="false"
                            label="手机号"
                            placeholder="请输入联系人手机号"
                            :rules="[{ required: true, message: '请正确填写联系人手机号', validator: checkPhone }]"
                        />
                    </li>
                    <li class="row-box">
                        <van-field
                            class="item-row f-s-b user-name"
                            v-model.trim="contactsInfo.id"
                            required
                            name="id"
                            :border="false"
                            label="证件号"
                            placeholder="请输入联系人证件号"
                            :rules="[{ required: true, message: '请正确填写联系人证件号', validator: checkId }]"
                        />
                    </li>
                    <li class="row-box">
                        <van-field
                            class="item-row f-s-b user-name"
                            v-model.trim="contactsInfo.remarks"
                            name="remarks"
                            :border="false"
                            label="备注信息"
                            placeholder="请输入备注信息"
                        />
                    </li>
                </ul>

                <div class="contacts-title-box f-s-b g-b-500">
                    <div>
                        <span>报名人信息</span>
                    </div>
                    <div class="control-btn f-s-b">
                        <i v-touch:tap="changeUserListNumber(false)" class="iconhebei theme-color-font iconjianhao icon-size"></i>
                        <span class="number-box g-black-color g-b-500">{{userList.length}}</span>
                        <i v-touch:tap="changeUserListNumber(true)" class="iconhebei theme-color-font iconjiahao icon-size"></i>
                    </div>
                </div>

                <ul 
                    v-for="(item, index) in userList" :key="index"
                    class="body-rander-item explain-home-info-input"
                >
                    <li class="row-box">
                        <van-field
                            class="item-row f-s-b user-name"
                            v-model.trim="item.name"
                            required
                            :name="`name${index}`"
                            :border="false"
                            :label="`报名人`"
                            placeholder="请输入报名人姓名"
                            :rules="[{ required: true, message: '请正确填写报名人姓名', validator: checkName }]"
                        />
                        <i v-touch:tap="deleteItem(index)" class="iconhebei iconcuo icon-size delete-icon" v-if="userList.length>1"></i>
                    </li>
                    <li class="row-box">
                        <van-field
                            @input="onInput(item)"
                            class="item-row f-s-b user-name"
                            v-model.trim="item.id"
                            required
                            :name="`id${index}`"
                            :border="false"
                            label="证件号"
                            :error-message="item.idNumberErrorText"
                            placeholder="请输入报名人证件号"
                            :rules="[{ required: true, message: '请正确填写报名人证件号', validator: checkId }]"
                        />
                    </li>
                    <li class="row-box">
                        <van-field
                            class="item-row f-s-b user-name"
                            v-model.trim="item.phone"
                            required
                            type="tel"
                            maxlength="11"
                            :name="`phone${index}`"
                            :border="false"
                            label="手机号"
                            placeholder="请输入报名人手机号"
                            :rules="[{ required: true, message: '请正确填写报名人手机号', validator: checkPhone }]"
                        />
                    </li>
                </ul>

                <!-- <ul class="body-rander-item"></ul> -->

                <ul class="body-container ">
                    <li class="title">温馨提示</li>
                    <van-image 
                        class="body-iamge"
                        lazy-load
                        fit="contain"
                        :src="imageList[0]" 
                    />
                    <li class="item ">
                        温馨提示：如需取消请提前1天取消，预约后不参加将被纳入馆方黑名单，一年内不可再次预约馆方任何活动            
                    </li>

                </ul>
            </div>

            <div class="foot f-c">
                <!-- <div class="btn f-c">确认预约</div> -->
                <van-button class="btn f-c" block type="info" native-type="submit">
                    确认预约
                </van-button>
            </div>

            <van-calendar 
                v-model="show" 
                @confirm="onConfirm" 
                safe-area-inset-bottom	
                position="bottom"
                color="#4282FF"
            />
            <!-- :formatter="formatter" -->

            <van-popup 
                position="bottom"
                v-model="timeShow"
                round
                :style="{ height: '50%' }"
                :close-on-popstate="true"
                :safe-area-inset-bottom="true"
            >
                <van-datetime-picker
                    v-model="time"
                    type="time"
                    :min-hour="9"
                    :max-hour="18"
                    @confirm="onChangeTime"
                    @cancel="onChangeTime"
                />
            </van-popup>

            <van-popup
                closeable
                close-icon="close"
                v-model="languageShow"
                position="bottom"
                round
                :style="{ height: '180px' }"
                :close-on-popstate="true"
                :safe-area-inset-bottom="true"
            >
                <van-radio-group 
                    v-model="radio"
                    class="language-box f-c"
                >
                    <van-cell-group class="language">
                        <van-cell class="language-row f-s-b" title="中文" clickable @click="radio = '1'">
                            <van-radio slot="right-icon" name="1" />
                        </van-cell>
                        <van-cell class="language-row f-s-b" title="English" clickable @click="radio = '2'">
                            <van-radio slot="right-icon" name="2" />
                        </van-cell>
                    </van-cell-group>
                </van-radio-group>
            </van-popup>

        </div>

    </van-form>

</template>

<script>
    import util from '@util';
    import { 
        Field,
        Calendar,
        Popup,
        DatetimePicker,
        RadioGroup, 
        Radio,
        Cell, 
        CellGroup,

        Form, 
        Button,
    } from 'vant';
    import { 
        getActivityDetailUrl, 
        commitActivitySignUpUrl,
        checkActivitysignUpUrl,
    } from '@ticketUrl';
    export default {
        data() {
            return {
                phonePattern: /^1[3456789]\d{9}$/,
                idPattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
                imageList:[require('@image/home/21321321.png'),],
                name:'',
                time: '09:00',
                // date: util.formatTime(new Date(), "yyyy-MM-dd"),
                date: '',
                show: false,
                timeShow: false,
                languageShow: false,
                radio: '1',
                narratorNumber:1,
                teamNumer:1,
                contactsInfo: {
                    name: '',
                    phone: '',
                    id: '',
                    remarks: '',

                    // name: '行嘛是的',
                    // phone: '15928176933',
                    // id: '510109198712211234',
                    // remarks: '备注',
                },
                userList: [
                    {
                        name: '',
                        phone: '',
                        id: '',
                        idNumberErrorText:''

                        // name: '行嘛',
                        // phone: '15928176933',
                        // id: '510109198712211234',
                        // idNumberErrorText:''
                    },
                ],
                option:{},
                isShowBtn: false,
                activityId: '',
                //  检查用户是否报名过的计数
                requestCount: 0,
            }
        },
        created() {
            this.getActivityDetai();
        },
        methods: {
            getActivityDetai(){
                const {
                    activityId: id,
                    applyActivityDate = ''
                } = this.$route.query;
                this.activityId = id;
                this.applyActivityDate = applyActivityDate;
                this.$http.get(getActivityDetailUrl,{ params: { id }})
                .then(res=>{
                    const {
                        data
                    } = res;
                    data._startTimeStr = util.formatTime(new Date(data.startTime),'时分秒');
                    data._endTimeStr = util.formatTime(new Date(data.endTime),'时分秒');
                    if ( new Date().getTime() < data.applyEndTime === false) {
                        this.btnTxt = "已截止报名";
                    } else if( !(data.surplusQuota > 0) ) {
                        this.btnTxt = "名额已满";
                    } else if( data.status !== 1  ) {
                        this.btnTxt = "已过报名时间";
                    }
                    this.isShowBtn = (new Date().getTime() < data.applyEndTime) && (data.surplusQuota > 0) && (data.status === 1)
                    this.option = data;
                })
            },
            onSubmit(values) {
                // console.log('submit', values);
                if(values) {
                    this.checkUserListIsSingnUp();
                }
            },
            //  检查所有用户是否有已经报名过的
            checkUserListIsSingnUp(){
                this.requestCount = 0;
                this.userList.map(item=>{
                    this.requestCount++
                    this.checkUserSingnUp(item)
                })
            },
            checkUserSingnUp(item){
                item.idNumberErrorText = '';
                this.$http.get(checkActivitysignUpUrl,{
                    params: {
                        id: this.activityId,
                        cardNo: item.idNumber
                    }
                }).then(res=>{
                    this.requestCount--;
                    var {
                        data = 2,
                    } = res;
                    // console.log('检查',res)
                    if(data === 2){
                        item.idNumberErrorText = '此证件号码已报名';
                        return
                    }
                    
                    if( data === 1 && this.requestCount === 0 ){
                        console.log('检查完毕')
                        this.signUpData();
                    }
                })
            },
            signUpData(){

                var temparray = this.userList;
                let flag = true;
                for (let index = 0, len = temparray.length; index < len; index++) {
                    const element = temparray[index];
                    if(element.idNumberErrorText !== ''){
                        flag = false;
                        break;
                    }
                }
                if(!flag) return;

                var applicant = [];

                this.userList.forEach(item => {
                    applicant.push({
                        name: item.name,
                        cardType: '0',//  0：身份证，1:护照
                        cardNo: item.id,
                        phone: item.phone,
                    })
                });

                const data = {
                    userId: this.getUserId,
                    activityId: this.activityId,
                    userVo: {
                        name: this.contactsInfo.name,
                        cardType: '0',//  0：身份证，1:护照
                        cardNo: this.contactsInfo.id,
                        phone: this.contactsInfo.phone,
                    },
                    applicant,
                    remark: this.contactsInfo.remarks,
                    //  渠道（0：窗口售票  1：微信售票 2：pc官网）	
                    sellMethod: '1',
                    applyActivityDate: this.applyActivityDate,
                };

                var tempFlag = false;
                //  检验 用户信息手动录入相同的游客
                for (let index = 0, len = this.userList.length - 1; index < len; index++) {
                    const out = this.userList[index];
                    if(tempFlag){
                        return ;
                    }
                    for (let index2 = index + 1, len2 = this.userList.length; index2 < len2; index2++) {
                        const inner = this.userList[index2];
                        if(out.id === inner.id){
                            tempFlag = true;
                            inner.idNumberErrorText = '游客信息重复';
                        }
                    }
                }

                if(tempFlag){
                    return ;
                }

                this.$http.post(commitActivitySignUpUrl, data)
                .then(res=>{
                    const {
                        data,
                        msg = ''
                    } = res;
                    if(JSON.stringify(data) != '{}'){
                        this.$router.push({name:'activitySuccess',query:{ id: data.id }});
                    }
                })

            },
            deleteItem(index){
                return ()=> { this.userList.splice(index,1) }
            },
            changeUserListNumber(type = true){
                return ()=> {
                    if(type){
                        this.userList.push({name: '', id: '', idNumberErrorText:''});
                    }else if(type === false && this.userList.length>1){
                        this.userList.splice(this.userList.length-1,1)
                    }
                }
            },
            onConfirm(date) {
                this.show = false;
                this.date = util.formatTime(new Date(date), "yyyy-MM-dd");
            },
            onChangeLanguage() {
                this.languageShow = !this.languageShow;
            },
            onChangeTime() {
                this.timeShow = !this.timeShow;
            },
            onChangeDate() {
                this.show = true;
            },
            onInput(item){
                item.idNumberErrorTxt = ''
            },
            checkName(v){
                return /^[\u4e00-\u9fa5_a-zA-Z]{2,10}$/.test(v)
                // return v === ""? false : true;
            },
            onChangeNumber(type = 'narratorNumber',flag = true){
                return ()=>{
                    if(flag){
                        this[type]++
                    }else{
                        if(this[type]>1) {
                            this[type]--;
                        }
                    }
                }
            },
            checkPhone(v){
                return this.phonePattern.test(v)
                // return new Promise(resolve => {
                //     this.$toast.loading({
                //         forbidClick: true,
                //         message: '验证中...'
                //     });
                //     setTimeout(() => {
                //         this.$toast.clear();
                //         resolve(this.phonePattern.test(v));
                //     }, 700);
                // });
            },
            checkId(v){
                return this.idPattern.test(v);
            },
            formatter(day) {
                const month = day.date.getMonth() + 1;
                const date = day.date.getDate();
                if (month === 5) {
                    if (date === 1) {
                    day.topInfo = '劳动节';
                    day.bottomInfo = '劳动节';
                    day.text = '劳动节';
                    } else if (date === 4) {
                    day.topInfo = '五四青年节';
                    } else if (date === 11) {
                    day.text = '今天';
                    }
                }
                if (day.type === 'start') {
                    day.bottomInfo = '入住';
                } else if (day.type === 'end') {
                    day.bottomInfo = '离店';
                }
                return day;
            }
        },      
        computed: {
            getUserId(){
                return this.$store.state.userInfo.userId || ''
            },
        },
        components:{
            [Field.name]: Field,
            [Calendar.name]: Calendar,
            [Popup.name]: Popup,
            [DatetimePicker.name]: DatetimePicker,
            [RadioGroup.name]: RadioGroup, 
            [Radio.name]: Radio,
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,

            [Form.name]: Form,
            [Button.name]: Button,
        }
    }
</script>

<style lang="less" scoped>
    @import "./style/home-public-style.less";
    .container{
        height: ~"calc(100% - 50px)" !important;
        // padding-bottom: 50px;
        .header{
            position: relative;
            padding: 0 35px 0 65px;
            box-sizing: border-box;
            background-color: #ffffff;
            height: 56px;
            color: #9C9C9C;
            .header-item{
                white-space: nowrap;
                width: auto;
                position: relative;
                text-align: center;
            }
            .item-line{
                width: 30%;
                border-bottom: 1px dotted #9C9C9C;
            }
            .header-item-active{
                margin-left: -25px;
                &::before{
                    background-color: #4282FF;
                    content: '';
                    border-radius: 2px;
                    height: 5px;
                    width: 65px;
                    position: absolute;
                    bottom: -10px;
                    left: 50%;
                    transform: translateX(-50%);
                }
            }
        }

        .body{
            // margin-bottom: 10px;
            padding: 7px;
            .body-rander-item{
                background-color: #ffffff;
                overflow: hidden;
                border-radius:5px;
                box-shadow:3px 1px 6px 0px rgba(224,224,224,0.5);
                margin-bottom: 7px;
                .row-box{
                    position: relative;
                    box-sizing: border-box;
                    height: 50px;
                    padding: 0 12px;
                    background-color: #ffffff;
                    &:last-child{
                        .item-row{
                            border: 0;
                        }
                    }
                    .delete-icon{
                        color: #787D88;
                        position: absolute;
                        right: 7px;
                        top: 13px;
                        z-index: 2;
                        // top: 50%;
                        // transform: translateY(-50%);
                        &::before{
                            font-size: 20px;
                        }
                    }
                    .item-row{
                        border-bottom: .5px solid #CBCBCB;
                        height: 100%;
                        background-color: transparent;
                        font-size: 14px;
                    }
                    .right-control{
                        color: #9599A2;
                        position: absolute;
                        top: 50%;
                        overflow: hidden;
                        transform: translateY(-50%);
                        left: 90px;
                        right: 12px;
                        .icon-size{
                            &::before{
                                font-weight: 500;
                            }
                        }
                    }
                    .number-control{
                        justify-content: flex-start;
                        .number-box{
                            margin: 0 10px;
                            display: inline-flex;
                            vertical-align: top;
                            width:65px;
                            height:22px;
                            box-sizing: border-box;
                            border:1px solid rgba(212,212,212,1);
                        }
                        .number-icon-size{
                            &::before{
                                font-size: 20px;
                                font-weight: 500;
                            }
                        }
                    }
                }
                .info-row{
                    padding-top: 10px;
                    padding-bottom: 10px;
                    align-items: baseline;
                    height: auto;
                    justify-content: flex-start;
                    font-size: 12px;
                    color: #979899;
                    .left-txt{
                        margin-left: 12px;
                        width: 80px;
                        text-align-last: justify;
                        color: #61666C;
                        font-weight: 500;
                    }
                    .right-txt{
                        width: ~"calc(100% - 85px)";
                    }
                }
                .info-title{
                    padding-left: 0;
                    padding-right: 0;
                    margin: 0 12px;
                    border-bottom: .5px solid #CCCCCC;

                    align-items: baseline;
                    justify-content: space-between;
                    .inner-row{
                        align-items: baseline;
                    }
                    .info-left{
                        max-width: ~"calc(100% - 120px)";
                        font-size:16px;
                        font-weight:500;
                        color:rgba(67,68,70,1);
                        .icon-size{
                            margin-right: 12px;
                        }
                    }
                    .info-right{
                        display: block;
                        max-width: 130px;
                        color: #666666;
                        .count{
                            font-size: 17px;
                            margin-left: 3px;
                        }
                    }
                }
            }
            .body-container{
                position: relative;
                border-radius:5px;
                overflow: hidden;
                box-shadow:3px 1px 6px 0px rgba(224,224,224,0.5);
                background-size: 118px 142px;
                background-repeat: no-repeat;
                background-position: right 70%;
                background-image: url('../../lib/image/home/567.png');
                background-color:rgba(255,255,255,1);
                box-sizing: border-box;
                width: 100%;
                padding: 14px 30px;
                font-size: 12px;
                color: #565656;
                height: auto;
                &{
                    .item:last-child{
                        margin: 0;
                    }
                }
                .title{
                    text-align: center;
                    color: #242424;
                    font-size: 16px;
                }
                .small-title{
                    font-size: 14px;
                    color: #565656;
                }
                .body-iamge{
                    width: 100%;
                    margin: 10px 0;
                }
                .item{
                    margin-bottom: 10px;
                }
                .time{
                    padding-left: 9px;
                    letter-spacing: 1px;
                }
            }
            .contacts-title-box{
                padding-left: 12px;
                padding-right: 12px;
                height: 50px;
                font-size: 14px;
                color: #555555;
                // justify-content: flex-start;
                .icon-size{
                    margin-right: 5px;
                    &::before{  
                        // font-size: 22px;
                    }
                }
                .look-narrators{
                    border: 0;
                    padding: 3px 6px;
                    font-size: 15px;
                    color:rgba(255,255,255,1);
                    background:rgba(92,162,253,1);
                    border-radius:3px;
                }
                .control-btn{
                        .number-box{
                            margin: 0 6px;
                            width: 24px;
                            height: 24px;
                            font-size: 14px;
                            display: inline-flex;
                            justify-content: center;
                            align-items: center;
                            border:1px solid rgba(212,212,212,1);
                        }
                        .icon-size{
                            &::before{
                                font-size: 22px;
                            }
                        }
                    }
            }
        }

        .foot{
            background-color: #f0f1f4;
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            height: 50px;
            .btn{
                border: 0;
                font-size: 15px;
                color:rgba(255,255,255,1);
                width:332px;
                height:50px;
                background:rgba(92,162,253,1);
                border-radius:12px;
            }
        }

        .language-box{
            box-sizing: border-box;
            padding: 50px;
            flex-direction: column;
            .language{
                width: 100%;
            }
            .language-row{
                width: 100%;
                height: 40px;
            }
        }
    }
</style>